<nz-header class="section-header">
  {{ "Neurodegenerative Disorders" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.modifiedFatigueImpactScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="17"
      [historyItems]="getTemplateItems(17)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
